import { useMemo } from 'react';

import { AddContextualData } from '@opendoor/observability';
import { useLocation } from '@remix-run/react';

import { Navigate } from 'platform/remix-run/react';

import { useAuthenticatedQueryParams } from 'sellDirect/legacyRoutingHelpers';

/**
 *  /dashboard/customer/:customerUUID/:addressUUID/sell/history
 *  /----0----/---1----/------2------/-----3------/--4-/--5---
 */
const parseCustomerAddressRoute = (pathname: string) => {
  const splitPath = pathname.split('/').slice(1);
  const addressUUID = splitPath[3];
  const customerUUIDOverride = splitPath[2];
  const basePath = `/dashboard/${splitPath[4]}`;
  const subPath = splitPath.length > 5 ? `/${splitPath.slice(5).join('/')}` : '';
  return { addressUUID, customerUUIDOverride, basePath, subPath };
};

/* TODO(@sellDirect): Deprecate any links to this route */
export default function LegacyCustomerRoute() {
  const { pathname } = useLocation();
  const { addressUUID, customerUUIDOverride, basePath, subPath } =
    parseCustomerAddressRoute(pathname);
  const queryParams = useAuthenticatedQueryParams(customerUUIDOverride);
  // Intentionally allowing all search params to propagate for JUST THIS redirect
  const customDisallowedSearchParams = useMemo(() => [], []);
  const navigateState = useMemo(() => ({ legacyRoute: 'customerAddress' }), []);

  return (
    <AddContextualData data={{ topLevelRoute: 'customer-address' }}>
      <Navigate
        to={`${basePath}/${addressUUID}${subPath}${queryParams}`}
        customDisallowedSearchParams={customDisallowedSearchParams}
        state={navigateState}
      />
    </AddContextualData>
  );
}
